export default {
  SETUP_GROUP: 'group_timelines/SETUP_GROUP',
  TIMELINES_PAGINATE: 'group_timelines/TIMELINES_PAGINATE',

  TIMELINES_REQUEST: 'group_timelines/TIMELINES_REQUEST',
  TIMELINES_SUCCESS: 'group_timelines/TIMELINES_SUCCESS',
  TIMELINES_FAILURE: 'group_timelines/TIMELINES_FAILURE',
}
